import request from './request';

import { ENDPOINT } from '../../constants/api';

const variations = {
  addOption({ channel, db, option, shopId, signal, variant }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload: { value: option },
      signal,
      url: `/${channel}/shops/${shopId}/variations/options/${variant}/values`,
    });
  },
  addVariant({ channel, db, shopId, signal, variant }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload: { value: variant },
      signal,
      url: `/${channel}/shops/${shopId}/variations/options`,
    });
  },
  deleteOption({ channel, db, option, shopId, signal, variant }) {
    return request.delete({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      signal,
      url: `/${channel}/shops/${shopId}/variations/options/${variant}/values/${option}`,
    });
  },
  deleteVariant({ channel, db, shopId, signal, variant }) {
    return request.delete({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      signal,
      url: `/${channel}/shops/${shopId}/variations/options/${variant}`,
    });
  },
  getVariations({ channel, db, shopId, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      signal,
      url: `/${channel}/shops/${shopId}/variations/options`,
    });
  },
};

export default variations;
